import { useIntl } from 'react-intl';

import { styled } from '@styles';

import { Button } from '@components/atoms/Button';

import filterIcon from 'images/filter.svg';

const ButtonWrapper = styled.div<{ isScrolledToBottom: boolean }>`
  width: 230px;
  justify-content: center;
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: ${(props) => props.theme.typography.smallFontSize};
  letter-spacing: 3px;
  display: flex;
  z-index: 1;
  transition: opacity 0.3;
  opacity: ${({ isScrolledToBottom }) => (isScrolledToBottom ? 0 : 1)};
  pointer-events: ${({ isScrolledToBottom }) =>
    isScrolledToBottom ? 'none' : 'auto'};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > img {
    height: 19px;
    margin-left: 5px;
  }
`;

export interface IFilterButton {
  onSubmit: () => void;
  isScrolledToBottom: boolean;
}

export const FilterButton: React.FC<IFilterButton> = ({
  onSubmit,
  isScrolledToBottom,
}) => {
  const intl = useIntl();

  return (
    <ButtonWrapper isScrolledToBottom={isScrolledToBottom}>
      <Button fullWidth onClick={onSubmit} size="sm" color="primary">
        <Wrapper>
          {intl.formatMessage({
            defaultMessage: 'Filter',
            id: '9Obw6C',
          })}
          <img src={filterIcon} alt="filter icon" />
        </Wrapper>
      </Button>
    </ButtonWrapper>
  );
};
FilterButton.displayName = 'FilterButton';
